import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { Http } from "@angular/http";
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ForgotPaswordService {

  constructor(private http: HttpClient) { }


  ForgotPassword(formbody) {
    return this.http.post(environment.ApiUrl + '/api/forgot-password', formbody);
  }

  ResetPassword(formbody): any {
    return this.http.post(environment.ApiUrl + '/api/reset-password', formbody);
  }

  validateCode(code) {
    const body = {
      "Security_Code": code
    }
    return this.http.post(environment.ApiUrl + '/api/password-link', body).pipe(map(res => res));
  }

}
